function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext } from 'react';
import styles from './TitleField.module.scss';
import cs from 'classnames';
import I18n from '../../I18n/I18n/I18n';
import HelpTemplate from '../HelpTemplate/HelpTemplate';
import { getInputDescription } from '../Widgets/wrapSchemaWidget';
import H from '../../H/H';
import WidgetSizeContext from '../WidgetSizeContext/WidgetSizeContext';
import ShowTitleContext from './ShowTitleContext';
import useIndentFields from '../IndentFieldsContext/useIndentFields';

// react-jsonschema-form TitleField props -> { id: string; title: string; required: boolean }

export default function TitleField(_ref) {
  var children = _ref.children,
    id = _ref.id,
    text = _ref.text,
    title = _ref.title,
    escape = _ref.escape,
    formContext = _ref.formContext,
    help = _ref.help,
    description = _ref.description,
    DescriptionField = _ref.DescriptionField,
    groupUiIcons = _ref.groupUiIcons;
  var showText = useContext(ShowTitleContext);
  var widgetSize = useContext(WidgetSizeContext);
  var _text = typeof text !== 'undefined' ? text : title;
  var _useIndentFields = useIndentFields(),
    indentClassName = _useIndentFields.indentClassName;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cs('_dm-form-group__label', '_dm__smart-text-break', "_dm-form-group__label--".concat(widgetSize), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      'assistive-text': !showText
    }, styles.container, showText), '_dm-form-group__label--print', formContext.isPrintView), '_dm-form-group__label--card', formContext.isCardView), styles.description, showText && !!description), indentClassName, indentClassName))
  }, /*#__PURE__*/React.createElement(H, {
    id: id,
    className: styles.heading
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: _text,
    escape: escape
  })), groupUiIcons, !formContext.isPrintView && /*#__PURE__*/React.createElement(HelpTemplate, {
    description: getInputDescription(help),
    i18n: text
  })), !formContext.isPrintView && !formContext.isCardView && description && DescriptionField && /*#__PURE__*/React.createElement(DescriptionField, {
    description: description.text,
    escape: description.escape
  }), children);
}